module.exports = __webpack_public_path__ + "static/media/indicator-cut.2d3a29f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/indicator-cut.png
// module id = 412
// module chunks = 0